export default __webpack_public_path__ + "static/media/success-circle-fill.884e8d30.svg";